// extracted by mini-css-extract-plugin
export default {"searchTargetChipSelected":"SearchBarTargetChips_searchTargetChipSelected__NNjFv","searchTargetChip":"SearchBarTargetChips_searchTargetChip__RMOnl"};